module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }